var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Button, Card, Flex, Popconfirm, theme, Tooltip, Typography, } from '@robinpowered/ui-kit';
import { useEventDetailContext, } from '../../context/EventDetailContextProvider';
import { CollapsibleCard } from '../../../components/common/CollapsibleCard';
import { keyframes } from '@emotion/react';
import { calcLogarithmicGrowth } from '../../../utils/utils';
import { useTranslation } from 'react-i18next';
import { SpaceInfoHeader } from '../../../components/SpaceDetails/SpaceInfoHeader';
import { ServiceRequest } from './ServiceRequest';
import { SpaceBuffer } from './SpaceBuffer';
import { SpaceRequest } from './SpaceRequest';
import { EventDetailsSuccessActions } from '../../types';
import { CheckInStatus } from '../CheckInStatus';
import { useConfig } from '../../../context/ConfigContext';
import { COMPOSER_DRAWER_WIDTH } from '../../../constants/drawerSizes';
import { useRecentSaveCooldown } from '../../hooks/useRecentSaveCooldown';
import { SpaceMovePicker } from './SpaceMovePicker';
export var SpaceCard = function (_a) {
    var _b, _c, _d;
    var timeFormat = _a.timeFormat;
    var t = useTranslation('meetingRooms').t;
    var _e = useEventDetailContext(), spaceData = _e.spaceData, event = _e.event, removeSpaceInvitee = _e.removeSpaceInvitee, onError = _e.onError, refetchEvent = _e.loadEvent, onSuccess = _e.onSuccess;
    var spaces = useMemo(function () { return Array.from(spaceData.values()); }, [spaceData]);
    /* There can only be 1 delete operation at a time */
    var _f = __read(useState(null), 2), isRemovingSpace = _f[0], setisRemovingSpace = _f[1];
    var _g = __read(useState(false), 2), changeRoomOpen = _g[0], setChangeRoomOpen = _g[1];
    // Edit-then-move guard: a fresh composer save is still syncing, and a
    // /move against it would copy stale data.
    var recentlySaved = useRecentSaveCooldown((_b = event === null || event === void 0 ? void 0 : event.id) !== null && _b !== void 0 ? _b : '');
    var eventUid = event === null || event === void 0 ? void 0 : event.uid;
    /* @TODO move this to a hook for managing spaces */
    var handleRemoveSpace = useCallback(function (spaceInviteeId, spaceId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event === null || event === void 0 ? void 0 : event.id)) {
                        return [2 /*return*/];
                    }
                    setisRemovingSpace(spaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeSpaceInvitee(event.id, spaceInviteeId)];
                case 2:
                    result = _a.sent();
                    if (result) {
                        // Always refetch after a successful delete
                        refetchEvent();
                        onSuccess(EventDetailsSuccessActions.REMOVE_SPACE_INVITEE);
                    }
                    else {
                        onError(new Error('Failed to remove space, please try again.'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setisRemovingSpace(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [removeSpaceInvitee, event === null || event === void 0 ? void 0 : event.id, refetchEvent, onError, onSuccess]);
    // Per-space Remove on the card requires event_permissions.update — same rule
    // as EditEventComposer.checkUserCanDeleteSpace. Users with only
    // update_as_space (no update) edit via the space calendar but do not get
    // Remove on individual space cards; they use footer Delete (remove_space /
    // cancel) instead. See useEditFooterMatrix and EVENT_COMPOSER_ARCHITECTURE.md
    // § Space removal permissions.
    var userCanUpdateEvent = !!((_c = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _c === void 0 ? void 0 : _c.update);
    if (!spaces)
        return null;
    var disableToggle = spaces.length < 3;
    if (!eventUid)
        return null;
    // A request-only organizer space can never change rooms (permanent — it
    // outranks the cooldown). Otherwise a fresh composer save still syncing
    // means a /move against it would copy stale data, so "change room" waits
    // out the cooldown.
    var organizerIsRequestOnly = !!((_d = spaces.find(function (space) { return space.isOrganizer; })) === null || _d === void 0 ? void 0 : _d.is_managed);
    var changeRoomDisabledReason = organizerIsRequestOnly
        ? t('eventDetails.space.request_only_change_tooltip')
        : recentlySaved
            ? t('eventDetails.space.recent_save_tooltip')
            : null;
    var listProps = {
        eventSpaces: spaces,
        eventUid: eventUid,
        userCanUpdateEvent: userCanUpdateEvent,
        onRemoveSpace: handleRemoveSpace,
        isRemovingSpace: isRemovingSpace,
        timeFormat: timeFormat,
        changeRoomDisabledReason: changeRoomDisabledReason,
        onChangeRoom: function () { return setChangeRoomOpen(true); },
    };
    return (_jsxs(_Fragment, { children: [disableToggle ? (_jsx(Flex, { gap: 12, vertical: true, children: _jsx(SpaceCardList, __assign({}, listProps)) })) : (_jsx(CollapsibleCard, { title: t('eventDetails.space.title_plural', {
                    count: spaces.length,
                }), defaultExpanded: true, children: _jsx(SpaceCardList, __assign({}, listProps)) })), _jsx(SpaceMovePicker, { open: changeRoomOpen, onClose: function () { return setChangeRoomOpen(false); } })] }));
};
var SpaceCardList = function (_a) {
    var _b;
    var eventSpaces = _a.eventSpaces, eventUid = _a.eventUid, userCanUpdateEvent = _a.userCanUpdateEvent, onRemoveSpace = _a.onRemoveSpace, isRemovingSpace = _a.isRemovingSpace, timeFormat = _a.timeFormat, changeRoomDisabledReason = _a.changeRoomDisabledReason, onChangeRoom = _a.onChangeRoom;
    var token = theme.useToken().token;
    var t = useTranslation('meetingRooms').t;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var _c = useConfig(), environmentUrls = _c.environmentUrls, userContext = _c.userContext;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var orgSlug = (_b = userContext === null || userContext === void 0 ? void 0 : userContext.currentOrg) === null || _b === void 0 ? void 0 : _b.slug;
    var spaceActions = function (space) {
        if (!userCanUpdateEvent)
            return [];
        // The organizer space is the event's calendar identity — removing it
        // would orphan the event, so it gets no Remove. Changing rooms is the
        // standalone details move (see useOrganizerSpaceMove).
        var changeRoomDisabled = !!changeRoomDisabledReason;
        // A request-only space is locked; per-space, so an anomalous
        // managed-plus-regular event only locks the managed card.
        var deleteDisabledReason = space.is_managed
            ? t('eventDetails.space.request_only_remove_tooltip')
            : null;
        var deleteDisabled = !!deleteDisabledReason;
        if (space.isOrganizer) {
            return [
                _jsx(Tooltip, { title: changeRoomDisabledReason, children: _jsx("span", { style: {
                            display: 'inline-block',
                            width: '100%',
                            cursor: changeRoomDisabled ? 'not-allowed' : undefined,
                        }, children: _jsx(Button, { type: "text", style: {
                                width: '100%',
                                alignSelf: 'flex-start',
                                pointerEvents: changeRoomDisabled ? 'none' : undefined,
                            }, size: "small", disabled: changeRoomDisabled, onClick: onChangeRoom, children: t('eventDetails.space.change_room') }) }) }, space.id),
            ];
        }
        return [
            _jsx(Popconfirm, { title: tSpaceBooking('remove_space.title'), description: tSpaceBooking('remove_space.description'), styles: { root: { maxWidth: COMPOSER_DRAWER_WIDTH } }, onConfirm: function () { return onRemoveSpace(space.inviteeId, space.id); }, 
                // The tooltip span stays clickable (that's what makes it hoverable),
                // so without this a click on the disabled Remove still opens the
                // confirm — and confirming would remove the space.
                disabled: deleteDisabled, children: _jsx(Tooltip, { title: deleteDisabledReason, children: _jsx("span", { style: {
                            display: 'inline-block',
                            width: '100%',
                            cursor: deleteDisabled ? 'not-allowed' : undefined,
                        }, children: _jsx(Button, { type: "text", style: {
                                width: '100%',
                                alignSelf: 'flex-start',
                                color: deleteDisabled ? undefined : token.colorError,
                                pointerEvents: deleteDisabled ? 'none' : undefined,
                            }, size: "small", disabled: !!isRemovingSpace || deleteDisabled, loading: isRemovingSpace === space.id, children: isRemovingSpace === space.id
                                ? t('eventDetails.space.removing_space')
                                : t('eventDetails.space.remove_space') }, space.id) }) }, space.id) }, space.id),
        ];
    };
    return (_jsx(Flex, { gap: 12, vertical: true, children: eventSpaces.map(function (space, index) {
            var _a, _b;
            var actions = spaceActions(space);
            var spaceDetailsUrl = orgSlug && space.location_id
                ? "".concat(dashboardUrl, "/").concat(orgSlug, "/locations/").concat(space.location_id, "/spaces/").concat(space.id, "/details")
                : null;
            return (
            /* @TODO[Spaces] This component is reused a lot, move to common file */
            _jsxs(SpaceCardWrapper, { token: token, index: index, actions: actions, styles: {
                    actions: {
                        borderRadius: "0 0 ".concat(token.borderRadiusSM, "px ").concat(token.borderRadiusSM, "px"),
                    },
                }, children: [_jsx(SpaceCardBody, { children: _jsx(SpaceInfoHeader, { name: space.name, nameHref: spaceDetailsUrl, nameTooltip: (_a = space.location) === null || _a === void 0 ? void 0 : _a.address, showOrganizerLabel: space.isOrganizer, locationText: _jsx(Typography.Text, { type: "secondary", size: "small", children: t('eventDetails.formattedSpaceName.name', {
                                    spaceName: space.name,
                                    locationName: (_b = space.location) === null || _b === void 0 ? void 0 : _b.name,
                                }) }), capacity: (space === null || space === void 0 ? void 0 : space.capacity) || undefined, amenities: (space === null || space === void 0 ? void 0 : space.space_amenities.map(function (amenity) { return ({
                                id: amenity.id,
                                quantity: amenity.quantity,
                                amenityId: amenity.amenity_id,
                                name: amenity.amenity.name,
                            }); })) || [], image: space.image, imageAlt: space.name }) }), _jsx(Flex, { style: { padding: '0px 12px 12px 12px' }, children: _jsx(CheckInStatus, { timeFormat: timeFormat, spaceId: space.id.toString() }) }), space.is_managed && space.reservationApproval && (_jsx(SpaceRequest, { reservationApproval: space.reservationApproval, space: space })), space.id && eventUid && (_jsx(ServiceRequest, { spaceId: space.id.toString() })), space.buffer && _jsx(SpaceBuffer, { space: space })] }, space.id));
        }) }));
};
var fadeDown = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    top: -30px;\n  }\n  to {\n    opacity: 1;\n    top: 0px;\n  }\n"], ["\n  from {\n    opacity: 0;\n    top: -30px;\n  }\n  to {\n    opacity: 1;\n    top: 0px;\n  }\n"])));
var SpaceCardWrapper = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 0px;\n\n  animation: ", ";\n  animation-duration: ", "s;\n  animation-timing-function: cubic-bezier(0.65, -0.25, 0.38, 1.19);\n  animation-fill-mode: forwards;\n\n  .ant-card-body {\n    padding: 0px;\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n\n  .ant-card-actions {\n    padding: ", "px;\n    background: ", ";\n\n    li {\n      margin: 0px;\n    }\n  }\n"], ["\n  border-radius: 4px;\n  padding: 0px;\n\n  animation: ", ";\n  animation-duration: ", "s;\n  animation-timing-function: cubic-bezier(0.65, -0.25, 0.38, 1.19);\n  animation-fill-mode: forwards;\n\n  .ant-card-body {\n    padding: 0px;\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n\n  .ant-card-actions {\n    padding: ", "px;\n    background: ", ";\n\n    li {\n      margin: 0px;\n    }\n  }\n"])), fadeDown, function (props) {
    /* We want to delay the animation on subsequent components */
    return calcLogarithmicGrowth(0.2, 0.5, 0.5, props.index + 1);
}, function (_a) {
    var token = _a.token;
    return token.paddingXS;
}, function (_a) {
    var token = _a.token;
    return token.colorBgLayout;
});
var SpaceCardBody = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 12px;\n"], ["\n  padding: 12px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
